<div
  class='mis-notifications-administration'
  fxLayout='column'
  [dir]="cService.selectedLanguage?.isRtl ? 'rtl' : 'ltr'"
>
  <mat-progress-bar
    [class.hidden]='cService.hideIndeterminateProgress'
    mode='indeterminate'
    class='fixed extreme-tl'
    color='accent'
  ></mat-progress-bar>

  <div class='dialog-container' style='position: relative'>
    <form [formGroup]='misContentForm' fxLayout='column'>
      <div fxLayout='row' fxFlex>
        <h3 class='dynamic-title' fxFlex>
					<span *ngIf='!isTooltipContent'>
						{{ 'MAINSIDENAV.misNotifications' | translate | uppercase }}
					</span>
          <span *ngIf='isTooltipContent'>
						{{ 'AGGRIDLOCALE.tooltips' | translate | uppercase }}
					</span>
        </h3>

        <div mat-dialog-close (click)='closeDialog()' class='close-button' vrm-button>
          <mat-icon>close</mat-icon>
        </div>
      </div>

      <mat-tab-group [selectedIndex]='selectedTabIndex' (selectedIndexChange)='selectedTabIndex = $event'>
        <!-- CREATE -->
        <mat-tab [disabled]='true'>
          <ng-template mat-tab-label>
            <span class='tab-header'>{{ 'CUSTOM_CONTENT.create' | translate }}</span>
          </ng-template>
          <ng-template matTabContent>
            <div class='create-form' fxLayout='column' fxFlex>
              <section *ngIf='isTooltipContent' class='padding-b-20'>
                <div fxLayout='column' fxLayoutAlign='space-between' formArrayName='tooltips'>
                  <ng-container
                    *ngFor='let tooltipForm of tooltips.controls; let i = index'
                    [formGroupName]='i'
                  >
                    <div fxFlex>
                      <label class='label'>
                        {{ 'CUSTOM_CONTENT.targetPage' | translate | uppercase }}
                        <span *ngIf="formRequiredFields.includes('menuID')" class='red-text'
                        >&nbsp; *</span
                        >
                      </label>
                      <mat-form-field appearance='outline'>
                        <mat-select formControlName='menuID'>
                          <mat-option
                            *ngFor='let navItem of availableVrmPageList'
                            [value]='navItem.id'
                          >
														<span *ngIf='navItem.isChild' class='bold'>
															{{
                              navItem.parentTranslatedName
                                ? navItem.parentTranslatedName
                                : navItem.parentName
                              }}
                              &nbsp; > &nbsp;
														</span>
                            {{
                            navItem.translatedName
                              ? navItem.translatedName
                              : navItem.name
                            }}
                          </mat-option>
                        </mat-select>

                        <mat-error *ngIf="tooltipForm['controls'].menuID.invalid">
                          {{ 'CUSTOM_CONTENT.required' | translate }}
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div fxLayout='row' fxFlex>
                      <div fxLayout='column'>
                        <div fxLayout='row'>
                          <label class='label padding-b-5 padding-r-10'>
                            {{ 'CUSTOM_CONTENT.contentLocation' | translate | uppercase }}
                          </label>

                          <mat-error
                            *ngIf="
															!tooltipForm['controls'].onTitle.value &&
															!tooltipForm['controls'].onMenu.value
														"
                          >
                            {{ 'CUSTOM_CONTENT.required' | translate }}
                          </mat-error>
                        </div>

                        <div fxLayout='row wrap' fxFlex>
                          <div class='checkbox-holder'>
                            <mat-checkbox
                              labelPosition='after'
                              formControlName='onTitle'
                              color='primary'
                              value='true'
                            >
                              {{ 'CUSTOM_CONTENT.pageTitle' | translate }}
                            </mat-checkbox>
                          </div>

                          <div class='checkbox-holder'>
                            <mat-checkbox
                              labelPosition='after'
                              formControlName='onMenu'
                              color='primary'
                              value='true'
                            >
                              {{ 'CUSTOM_CONTENT.navigationMenu' | translate }}
                            </mat-checkbox>
                          </div>
                        </div>
                      </div>

                      <span fxFlex></span>

                      <button
                        *ngIf='i !== 0'
                        mat-flat-button
                        [matTooltip]="'CUSTOM_CONTENT.removePage' | translate"
                        style='background: transparent'
                        (click)='removeTooltipPage(i)'
                      >
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>

                    <div *ngIf='tooltips.controls.length > 1' style='padding: 40px 0 40px 0'>
                      <div style='border-top: 1px solid #ccc'></div>
                    </div>
                  </ng-container>

                  <!-- TODO: Restore this button when multiple page target is well supported on the back-end -->
                  <!-- <div fxLayout="row" fxLayoutAlign="end" fxFlex>
                                        <button mat-flat-button (click)="addTooltipToPage()" style="background: transparent;">
                                            <mat-icon>add</mat-icon> {{ 'CUSTOM_CONTENT.addToNewPage' | translate }}
                                        </button>
                                    </div> -->
                </div>
              </section>

              <section class='language-selection'>
                <label class='label'>{{ 'GENERIC.languages' | translate }}</label>

                <div class='notification-languages-list' [formGroup]='availableVariants'>
                  <div fxLayout='row wrap' fxFlex>
                    <div class='checkbox-holder'>
                      <mat-checkbox
                        labelPosition='after'
                        color='primary'
                        [checked]='true'
                        [disabled]='true'
                        value='English'
                      >
                        {{ 'English' | translate }}
                      </mat-checkbox>
                    </div>

                    <div *ngFor='let language of languageVariants' class='checkbox-holder'>
                      <mat-checkbox
                        labelPosition='after'
                        color='primary'
                        (change)='addRemoveVariant($event)'
                        [value]='language.country'
                        [formControlName]='language.country.toLowerCase()'
                      >
                        {{ language.country }}
                      </mat-checkbox>
                    </div>
                  </div>
                </div>

                <mat-hint>{{ 'CUSTOM_CONTENT.englishPrimaryLanguageInfo' | translate }}</mat-hint>
              </section>

              <!-- Language forms -->
              <ng-container formArrayName='variants'>
                <ng-container *ngFor='let variant of variants.controls; let i = index'>
                  <section fxLayout='column' class='notification-variants' [formGroupName]='i'>
                    <div fxLayout='row' fxLayoutAlign='space-between center'>
                      <div class='field width-20'>
                        <label class='label'>{{ 'GENERIC.language' | translate }}</label>
                        <mat-form-field appearance='outline'>
                          <input
                            matInput
                            type='text'
                            value=''
                            [readonly]='true'
                            formControlName='language'
                          />
                        </mat-form-field>
                      </div>

                      <div class='field width-70'>
                        <label class='label'>
													<span *ngIf='!isTooltipContent'>{{
                            'CUSTOM_CONTENT.headline' | translate
                            }}</span>
                          <span *ngIf='isTooltipContent'>{{
                            'GENERIC.title' | translate
                            }}</span>
                          <span
                            *ngIf="formRequiredFields.includes('subject')"
                            class='red-text'
                          >&nbsp; *</span
                          >
                        </label>
                        <mat-form-field appearance='outline'>
                          <input
                            matInput
                            type='text'
                            value=''
                            autocomplete='off'
                            formControlName='subject'
                          />

                          <mat-error *ngIf="variant['controls'].subject.invalid">
                            {{ 'CUSTOM_CONTENT.required' | translate }}
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div fxFlex fxLayout='column'>
                      <div class='field w-100'>
                        <label class='label'>
                          {{ 'CUSTOM_CONTENT.body' | translate }}
                          <span
                            *ngIf="formRequiredFields.includes('message')"
                            class='red-text'
                          >&nbsp; *</span
                          >
                        </label>
                        <mat-form-field appearance='outline'>
													<textarea
                            matInput
                            autocomplete='off'
                            rows='5'
                            formControlName='message'
                          ></textarea>

                          <mat-error *ngIf="variant['controls'].message.invalid">
                            {{ 'CUSTOM_CONTENT.required' | translate }}
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                  </section>
                </ng-container>
              </ng-container>

              <div fxFlex></div>

              <div class='padding-b-20'>
                <div mat-dialog-actions fxLayout='row' fxLayoutAlign='end center'>
                  <button mat-button vrm-button (click)='saveNotificationVariants()' class='bold'>
                    {{ 'CUSTOM_CONTENT.saveAndContinue' | translate }}
                  </button>
                </div>
              </div>
            </div>
          </ng-template>
        </mat-tab>

        <!-- PREVIEW -->
        <mat-tab [disabled]='true'>
          <ng-template mat-tab-label>
            <span class='tab-header'>{{ 'CUSTOM_CONTENT.preview' | translate }}</span>
          </ng-template>
          <ng-template matTabContent>
            <div fxLayout='column' fxFlex>
              <mat-drawer-container class='preview-container' fxFlex>
                <mat-drawer mode='side' opened>
                  <div
                    class='preview-languages'
                    fxFlex
                    fxLayout='column'
                    fxLayoutAlign='start center'
                    fxLayoutGap='20px'
                  >
                    <label class='label'>{{ 'GENERIC.language' | translate }}</label>
                    <mat-selection-list
                      [multiple]='false'
                      fxFlex
                      fxLayout='column'
                      fxLayoutAlign='start start'
                      fxLayoutGap='20px'
                      class='preview-language-selection'
                    >
                      <mat-list-option
                        (click)="previewNotification('english')"
                        [selected]="previewContent.notificationLanguage.toLowerCase() === 'english'"
                        class='preview-language-option'
                      >{{ 'English' | translate }}</mat-list-option
                      >

                      <ng-container *ngFor='let language of languageVariants'>
                        <mat-list-option
                          *ngIf='
														availableVariants.controls[language.country.toLowerCase()].value
													'
                          [selected]='
														previewContent.notificationLanguage.toLowerCase() ==
														language.country.toLowerCase()
													'
                          (click)='previewNotification(language.country.toLowerCase())'
                          class='preview-language-option'
                        >{{ language.country }}</mat-list-option
                        >
                      </ng-container>
                    </mat-selection-list>
                  </div>
                </mat-drawer>

                <mat-drawer-content>
                  <div class='preview-content padding-20' fxLayout='column' fxFlex>
                    <div class='preview-wrapper' fxFlex>
                      <div class='preview'>
                        <div class='previewing' *ngIf='!isTooltipContent'>
                          <div class='dialog-container'>
                            <h1
                              mat-dialog-title
                              class='dialog-title'
                              fxLayout='row'
                              fxLayoutAlign='space-between center'
                            >
															<span class='title'>{{
                                'CUSTOM_CONTENT.vrmNotification' | translate | uppercase
                                }}</span>
                            </h1>

                            <div class='content'>
                              <h2>{{ previewContent.contentTitle }}</h2>
                              <p>
                                {{ previewContent.contentMessage }}
                              </p>
                            </div>

                            <div
                              mat-dialog-actions
                              fxLayout='row'
                              fxLayoutAlign='center center'
                              class='actions'
                            >
                              <button
                                mat-button
                                vrm-button
                                style='color: white; padding-right: 0'
                              >
                                {{ 'CONTINUE' }}
                              </button>
                            </div>
                          </div>
                        </div>

                        <div *ngIf='isTooltipContent'>
                          <tooltip-viewer
                            [title]='previewContent.contentTitle'
                            [description]='previewContent.contentMessage'
                          ></tooltip-viewer>

                          <a
                            mat-flat-button
                            (click)='previewTooltipInNewTab()'
                            *ngIf='
															availableTooltipPreviews.length === 1;
															else showPreviewPageList
														'
                            style='
															color: blue;
															text-decoration: underline;
															background: transparent;
														'
                          >
                            {{ 'CUSTOM_CONTENT.previewInNewTab' | translate }}
                          </a>
                          <ng-template #showPreviewPageList>
                            <a
                              mat-flat-button
                              [matMenuTriggerFor]='tooltipPreviews'
                              style='
																color: blue;
																text-decoration: underline;
																background: transparent;
															'
                            >
                              {{ 'CUSTOM_CONTENT.previewInNewTab' | translate }}
                              <mat-icon style='line-height: 22px'
                              >arrow_drop_down
                              </mat-icon
                              >
                            </a>
                            <mat-menu #tooltipPreviews='matMenu' [overlapTrigger]='false'>
                              <button
                                type='button'
                                mat-menu-item
                                *ngFor='let page of availableTooltipPreviews'
                                (click)='previewTooltipInNewTab(page)'
                              >
																<span *ngIf='page.isChild' class='bold'>
																	{{
                                  page.parentTranslatedName
                                    ? page.parentTranslatedName
                                    : page.parentName
                                  }}
                                  &nbsp; > &nbsp;
																</span>
                                {{
                                page.translatedName
                                  ? page.translatedName
                                  : page.name
                                }}
                              </button>
                            </mat-menu>
                          </ng-template>
                        </div>
                      </div>
                    </div>

                    <div mat-dialog-actions fxLayout='row' fxLayoutAlign='space-between center'>
                      <button mat-button vrm-button class='bold' (click)='goPreviousTab()'>
                        {{ 'CUSTOM_CONTENT.back' | translate | uppercase }}
                      </button>
                      <button mat-button vrm-button class='bold' (click)='goNextTab()'>
                        {{ 'CUSTOM_CONTENT.saveAndContinue' | translate | uppercase }}
                      </button>
                    </div>
                  </div>
                </mat-drawer-content>
              </mat-drawer-container>
            </div>
          </ng-template>
        </mat-tab>

        <!-- AUDIENCE -->
        <mat-tab [disabled]='true'>
          <ng-template mat-tab-label>
            <span class='tab-header'>{{ 'CUSTOM_CONTENT.audience' | translate }}</span>
          </ng-template>

          <ng-template matTabContent>
            <div fxLayout='column' fxFlex>
              <div class='audience'>
                <section class='recipient-company'>
                  <div fxFlex fxLayout='column'>
                    <div class='field w-100'>
                      <label class='label'>{{ 'CUSTOM_CONTENT.company' | translate }}</label>

                      <angular2-multiselect
                        [data]='allowedCompanies'
                        [(ngModel)]='selectedCompanies'
                        [settings]='companyDropdownSettings'
                        formControlName='companies'
                      >
                      </angular2-multiselect>
                    </div>
                  </div>
                </section>

                <section
                  class='recipient-location'
                  [formGroup]='locations'
                  *ngIf='companySpecificLocations'
                >
                  <div fxFlex fxLayout='column' fxLayoutGap='20px'>
                    <div
                      class='field w-100'
                      *ngFor='let companyLocation of companySpecificLocations'
                    >
                      <label class='label'>{{ companyLocation.text }}</label>
                      <angular2-multiselect
                        [data]='companyLocation.data'
                        [(ngModel)]='companyLocation.selected'
                        [settings]='locationDropdownSettings'
                        [formControlName]='companyLocation.colName'
                      >
                      </angular2-multiselect>
                    </div>
                  </div>
                </section>
              </div>

              <div class='audience padding-b-20'>
                <div mat-dialog-actions fxLayout='row' fxLayoutAlign='space-between center'>
                  <button mat-button vrm-button class='bold' (click)='goPreviousTab()'>
                    {{ 'CUSTOM_CONTENT.back' | translate | uppercase }}
                  </button>
                  <button mat-button vrm-button class='bold' (click)='saveAudience()'>
                    {{ 'CUSTOM_CONTENT.saveAndContinue' | translate | uppercase }}
                  </button>
                </div>
              </div>
            </div>
          </ng-template>
        </mat-tab>

        <!-- SCHEDULE -->
        <mat-tab [disabled]='true'>
          <ng-template mat-tab-label>
            <span class='tab-header'>{{ 'CUSTOM_CONTENT.schedule' | translate }}</span>
          </ng-template>

          <ng-template matTabContent>
            <div fxLayout='column' fxFlex>
              <div class='schedule'>
                <section class='recipient-company' [formGroup]='displays'>
                  <div fxFlex fxLayout='column' [formGroup]='schedules'>
                    <div class='field w-100'>
                      <label class='label'>
                        {{ 'CUSTOM_CONTENT.publishDate' | translate }}
                        <span
                          *ngIf="formRequiredFields.includes('displayFrom')"
                          class='red-text'
                        >&nbsp; *</span
                        >
                      </label>

                      <mat-form-field appearance='outline' class='padding-b-10'>
                        <input
                          matInput
                          [matDatepicker]='displayFromPicker'
                          (focus)='displayFromPicker.open()'
                          formControlName='displayFrom'
                        />

                        <mat-datepicker-toggle
                          matSuffix
                          [for]='displayFromPicker'
                        ></mat-datepicker-toggle>
                        <mat-datepicker #displayFromPicker></mat-datepicker>

                        <mat-error
                          *ngIf='
														!schedules.controls.displayFrom.value &&
														schedules.controls.displayFrom.invalid
													'
                        >
                          {{ 'CUSTOM_CONTENT.required' | translate }}
                        </mat-error>

                        <mat-error
                          *ngIf='
														schedules.controls.displayFrom.value &&
														schedules.controls.displayFrom.invalid
													'
                        >
                          {{ 'CUSTOM_CONTENT.invalidDate' | translate }}
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class='field w-100'>
                      <label class='label'>
                        {{ 'CUSTOM_CONTENT.expiryDate' | translate }}
                        <span *ngIf="formRequiredFields.includes('displayTo')" class='red-text'
                        >&nbsp; *</span
                        >
                      </label>

                      <mat-form-field appearance='outline' class='padding-b-10'>
                        <input
                          matInput
                          [matDatepicker]='displayToPicker'
                          (focus)='displayToPicker.open()'
                          formControlName='displayTo'
                        />

                        <mat-datepicker-toggle
                          matSuffix
                          [for]='displayToPicker'
                        ></mat-datepicker-toggle>
                        <mat-datepicker #displayToPicker></mat-datepicker>

                        <mat-error
                          *ngIf='
														!schedules.controls.displayTo.value &&
														schedules.controls.displayTo.invalid
													'
                        >
                          {{ 'CUSTOM_CONTENT.required' | translate }}
                        </mat-error>

                        <mat-error
                          *ngIf='
														schedules.controls.displayTo.value &&
														schedules.controls.displayTo.invalid
													'
                        >
                          {{ 'CUSTOM_CONTENT.invalidDate' | translate }}
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class='displayDatePrecedenceError'>
                      <mat-error
                        *ngIf='
													schedules.errors &&
													(schedules.touched || schedules.dirty) &&
													schedules.errors.minGreaterThanMaxError
												'
                      >
                        {{ 'CUSTOM_CONTENT.displayFromCannotBeBeforeDisplayFrom' | translate }}
                      </mat-error>
                    </div>
                  </div>
                </section>

                <hr />

                <section class='acknowledgement'>
                  <div fxFlex fxLayout='column'>
                    <div class='field w-100'>
                      <label class='label'>{{
                        'CUSTOM_CONTENT.acknowledgement' | translate
                        }}</label>
                      <p>
                        {{ 'CUSTOM_CONTENT.acknowledgementText' | translate }}
                      </p>
                    </div>
                  </div>
                </section>
              </div>

              <div fxFlex></div>

              <div class='schedule padding-b-20'>
                <div mat-dialog-actions fxLayout='row' fxLayoutAlign='space-between center'>
                  <button mat-button vrm-button class='bold' (click)='goPreviousTab()'>
                    {{ 'CUSTOM_CONTENT.back' | translate | uppercase }}
                  </button>
                  <button mat-button vrm-button class='bold' (click)='setNotification()'>
                    {{ 'CUSTOM_CONTENT.setContent' | translate | uppercase }}
                  </button>
                </div>
              </div>
            </div>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </form>
  </div>
</div>
